import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OvCompactButton from '../atoms/OvCompactButton';
import OvVideoThumbnail from '../atoms/OvVideoThumbnail';
import OvRecordDetailsSection from '../molecules/OvRecordDetailsSection';
import OvReplaceVideoPosterDialog from '../molecules/OvReplaceVideoPosterDialog';
import { AdminVideo } from '../../../common/model/dto/video/admin-video';

interface OvVideoPosterSectionProps {
  video: AdminVideo;
  isEditable: boolean;
  onSaved: () => void;
}

const OvVideoPosterSection: FC<OvVideoPosterSectionProps> = ({
  video,
  isEditable,
  onSaved,
}) => {
  const { t } = useTranslation();
  const [isReplacing, setIsReplacing] = useState(false);

  return (
    <OvRecordDetailsSection
      title={t('videos.fields.poster')}
      action={
        isEditable && (
          <OvCompactButton
            tone="secondary"
            onClick={() => setIsReplacing(true)}
          >
            {t('videos.details.poster.title')}
          </OvCompactButton>
        )
      }
    >
      <OvVideoThumbnail
        src={video.poster_url}
        size="large"
        alt={t('videos.details.poster.previewAlt', { title: video.title })}
      />
      {isEditable && (
        <OvReplaceVideoPosterDialog
          video={video}
          isOpen={isReplacing}
          onClose={() => setIsReplacing(false)}
          onSaved={onSaved}
        />
      )}
    </OvRecordDetailsSection>
  );
};

export default OvVideoPosterSection;
